import { detectCardType } from "features/Licensing/Packs/PaymentModal/utils/creditCardValidation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCcVisa } from "@fortawesome/free-brands-svg-icons/faCcVisa";
import { faCcMastercard } from "@fortawesome/free-brands-svg-icons/faCcMastercard";
import { faCcAmex } from "@fortawesome/free-brands-svg-icons/faCcAmex";
import { faCcDiscover } from "@fortawesome/free-brands-svg-icons/faCcDiscover";
import { faCreditCard } from "@fortawesome/pro-regular-svg-icons";
import { type IconDefinition } from "@fortawesome/pro-solid-svg-icons";

interface CreditCardIconProps {
  cardNumber: string;
  className?: string;
}

const Icon = ({ icon, className }: { className?: string; icon: IconDefinition }) => {
  return <FontAwesomeIcon color={"#9C989E"} icon={icon} size={"lg"} className={className} />;
};

export const CardIcon = ({ cardNumber, className }: CreditCardIconProps) => {
  const cardType = detectCardType(cardNumber);

  switch (cardType) {
    case "visa":
      return <Icon icon={faCcVisa} className={className} />;
    case "mastercard":
      return <Icon icon={faCcMastercard} className={className} />;
    case "amex":
      return <Icon icon={faCcAmex} className={className} />;
    case "discover":
      return <Icon icon={faCcDiscover} className={className} />;
    default:
      return <Icon icon={faCreditCard} className={className} />;
  }
};
